import React, { useCallback, useMemo, useState } from 'react';
import { RuleGroupList as BaseRuleGroupList } from './rule-group-list';
import { RuleGroupContext } from './rule-group-registration-context';
export const CompoundRuleGroupList = _ref => {
  let {
    children,
    parentNodeRef,
    dataHook,
    hideShadow,
    accordionSize = 'tiny',
    accordionSkin = 'neutral'
  } = _ref;
  const [registeredGroups, setRegisteredGroups] = useState(new Map());
  const registerGroup = useCallback(_ref2 => {
    let {
      groupId,
      ruleGroup
    } = _ref2;
    setRegisteredGroups(prev => {
      if (prev.get(groupId) === ruleGroup) {
        return prev;
      }
      const next = new Map(prev);
      next.set(groupId, ruleGroup);
      return next;
    });
  }, []);
  const unregisterGroup = useCallback(groupId => {
    setRegisteredGroups(prev => {
      if (!prev.has(groupId)) {
        return prev;
      }
      const next = new Map(prev);
      next.delete(groupId);
      return next;
    });
  }, []);
  const contextValue = useMemo(() => ({
    registerGroup,
    unregisterGroup
  }), [registerGroup, unregisterGroup]);
  const ruleGroups = useMemo(() => Array.from(registeredGroups.values()), [registeredGroups]);
  return /*#__PURE__*/React.createElement(RuleGroupContext.Provider, {
    value: contextValue
  }, children, /*#__PURE__*/React.createElement(BaseRuleGroupList, {
    accordionSize: accordionSize,
    accordionSkin: accordionSkin,
    dataHook: dataHook,
    hideShadow: hideShadow,
    parentNodeRef: parentNodeRef,
    ruleGroups: ruleGroups
  }));
};
//# sourceMappingURL=compound-rule-group-list.js.map